export default {
  "content": "<rect width=\"44\" height=\"44\" rx=\"22\" fill=\"#4141A2\"/><path d=\"M31.634 22.366l-10-10a1.25 1.25 0 00-1.768 1.768l.853.852-5.988 10.478-.597-.598a1.251 1.251 0 10-1.768 1.768l5 5a1.25 1.25 0 101.768-1.768l-.42-.42 1.625-.931 1.32 1.32a3.126 3.126 0 004.42-4.42l-.115-.114 3.222-1.841.674.674a1.25 1.25 0 001.768-1.768h.006zm-7.317 5.7a.625.625 0 01-.884 0l-.838-.838 1.125-.643.598.598a.625.625 0 010 .882v.001zm-7.532-.674l-.421-.42L22 17l2.5 2.5-7.715 7.892z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "44",
    "height": "44",
    "viewBox": "0 0 44 44",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};